import { render, staticRenderFns } from "./CompetitorLogo.vue?vue&type=template&id=1377a336&scoped=true"
import script from "./CompetitorLogo.vue?vue&type=script&lang=ts&setup=true"
export * from "./CompetitorLogo.vue?vue&type=script&lang=ts&setup=true"
import style0 from "./CompetitorLogo.vue?vue&type=style&index=0&id=1377a336&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1377a336",
  null
  
)

export default component.exports